import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import "./assets/css/scroll.scss";
import "./assets/css/index.scss";
import "ant-design-vue/dist/antd.css";
import "./assets/css/reset.scss";
import "./assets/css/atom.scss";

import "@/assets/requireAllSvg.ts";

import lazyLoad from "@js/directive/lazy-load";
import i18n from "./i18n/index";
const pinia = createPinia();

const app = createApp(App);

app.use(pinia).use(router).use(lazyLoad).use(i18n).mount("#app");
